import React, { useContext, useEffect, useState } from 'react';
import { SidebarContext } from './SidebarContext';

interface IProps {
  title: string;
  defaultExpanded?: boolean;
  extraTopSpacing?: boolean;
  topDivider?: boolean;
  children: React.ReactNode;
}

export default function NavSection(props: IProps) {
  const { isCollapsed } = useContext(SidebarContext);
  const [expanded, setExpanded] = useState<boolean>(props.defaultExpanded ?? false);

  useEffect(() => {
    if (props.defaultExpanded) {
      setExpanded(true);
    }
  }, [props.defaultExpanded]);

  if (isCollapsed) {
    if (props.topDivider) {
      return (
        <>
          <li className="nav-item border-top my-2" aria-hidden="true" />
          {props.children}
        </>
      );
    }
    return <>{props.children}</>;
  }

  const headerSpacingClass = props.topDivider ? ' mt-2' : props.extraTopSpacing ? ' mt-3' : ' mt-0';
  const dividerClass = props.topDivider ? ' border-top pt-2' : '';

  return (
    <>
      <li className={`nav-item${headerSpacingClass}${dividerClass}`}>
        <button
          type="button"
          className="nav-link btn btn-link text-start w-100 px-3 d-flex align-items-center text-uppercase text-muted small fw-semibold"
          onClick={() => setExpanded(prev => !prev)}
          aria-label={props.title}
          aria-expanded={expanded}>
          <span className="flex-grow-1">{props.title}</span>
          <i className={`bi-chevron-${expanded ? 'down' : 'right'} ms-auto`}></i>
        </button>
      </li>
      {expanded && props.children}
    </>
  );
}
